import React from 'react'

export const SimulatorFuelOutputPrice = (data) => {
  const { output, contentfulData } = data
  const { section1Block2Titre, section1Block2Description } = contentfulData

  const lastIndexGreen = output.reduce(
    (acc, item, index) => (item.generalColor === 'green' ? index : acc),
    -1,
  )

  // console.log('output', output)

  return (
    <div className="w-full md:w-1/2 simulator-block bg-light-grey">
      <h3 className="title-block text-purple mr-8">{section1Block2Titre}</h3>
      <p>{section1Block2Description}</p>
      <div className="overflow-x-auto mt-5">
        <table className="min-w-full leading-normal">
          <tbody>
            {output.map((item, index) => {
              const isLastGreen = index === lastIndexGreen
              return (
                <>
                  <tr
                    key={index}
                    className={`text-16 ${
                      item.generalColor === 'green' ? 'text-light-green' : ''
                    }`}
                  >
                    <td className=" font-semibold simulator-table-title">
                      {item.lib}
                    </td>
                    <td className="simulator-table-price">{item.price}</td>
                    <td className="simulator-table-unit">{item.unit}</td>
                  </tr>
                  {isLastGreen && (
                    <tr key="spacer-row" style={{ height: '20px' }}></tr>
                  )}
                </>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
